import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { BusinessScope } from "@lib/constants/business-scope";

@Component({
  selector: "app-scope-selection-card",
  imports: [UiKitModule],
  templateUrl: "./scope-selection-card.component.html",
  styleUrl: "./scope-selection-card.component.scss",
})
export class ScopeSelectionCardComponent {
  @Input() scope!: { scope: BusinessScope; title: string; subtitle: string; image: string };
  @Input() isSelected: boolean = false;

  @Output() selectScope = new EventEmitter<BusinessScope>();

  onSelect() {
    this.isSelected = true;
    this.selectScope.emit(this.scope.scope);
  }
}
